import AppLayout from './app/AppLayout.vue'
import AppWrapper from './app/AppWrapper.vue'
import AuthLayout from './auth/AuthLayout.vue'

const layouts = {
  auth: AuthLayout,
  app: AppLayout,
  default: 'div',
}
const wrappers = {
  auth: 'div',
  app: AppWrapper,
  default: 'div',
}

function resolveLayouts(route) {
  const layoutName = route?.meta?.layoutName || 'default'
  const wrapperName = route?.meta?.wrapperName || layoutName
  const layout = layouts[layoutName] || layouts.default
  const wrapper = wrappers[wrapperName] || wrappers.default
  return { wrapper, layout, layoutName, wrapperName }
}

export default resolveLayouts
